import {gql} from '@apollo/client'

export default gql`
  query getCurrentUserData {
    currentUserData {
      id
      user_name
      survey_language
      trial_type
      section_1_completed_date
      surveys {
        id
        title
        completed_date
        section_2_completed_date
        section_3_completed_date
        problems {
          id
        }
      }
    }
  }
`